import { loan_application_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { loan_application } from '@axo/shared/data-access/types';
import { useMutation, useQueryClient } from 'react-query';
import { applicationKeys } from '../../cache-keys/applicationKeys';

export function useCreateApplicationCar() {
  const client = useQueryClient();
  const api = useAPI();

  return useMutation({
    mutationFn: async ({
      applicationID,
      data,
    }: {
      applicationID: string;
      data: loan_application.CreateCar;
    }) => await loan_application_api.postCar(api)(applicationID, data),

    onSettled: (_data, _error, variables) => {
      client.removeQueries(applicationKeys.cars(variables.applicationID));
      client.removeQueries(
        applicationKeys.root({ applicationID: variables.applicationID }),
      );
    },
  });
}
